import type {
  ApiResponse,
  CreateGiftcardSubcategoryRequest,
  GiftcardAsset,
  GiftcardBuyPercentage,
  GiftcardBuyRate,
  GiftcardSellRate,
  UpdateGiftcardBuyPercentageRequest,
  UpdateGiftcardRegionsRequest,
  UpdateGiftcardSubcategoryRequest
} from '../../types/ApiTypes';
import { apiManager } from '../api/ApiManager';

export class GiftcardService {
  async getBuyAssets(): Promise<ApiResponse<GiftcardAsset[]>> {
    return apiManager.get<GiftcardAsset[]>('/api/v1/admin/giftcard/buy-assets');
  }

  async getSellAssets(): Promise<ApiResponse<GiftcardAsset[]>> {
    return apiManager.get<GiftcardAsset[]>('/api/v1/admin/giftcard/sell-assets');
  }

  async toggleBuyAsset(type: string): Promise<ApiResponse<{ enabled: boolean }>> {
    return apiManager.post<{ enabled: boolean }>(`/api/v1/admin/giftcard/buy-assets/${encodeURIComponent(type)}/toggle`);
  }

  async toggleSellAsset(type: string): Promise<ApiResponse<{ enabled: boolean }>> {
    return apiManager.post<{ enabled: boolean }>(`/api/v1/admin/giftcard/sell-assets/${encodeURIComponent(type)}/toggle`);
  }

  async getBuyPercentage(): Promise<ApiResponse<GiftcardBuyPercentage>> {
    return apiManager.get<GiftcardBuyPercentage>('/api/v1/admin/giftcard/buy-percentage');
  }

  async updateBuyPercentage(data: UpdateGiftcardBuyPercentageRequest): Promise<ApiResponse> {
    return apiManager.put('/api/v1/admin/giftcard/buy-percentage', data);
  }

  async getSellRates(): Promise<ApiResponse<GiftcardSellRate[]>> {
    return apiManager.get<GiftcardSellRate[]>('/api/v1/admin/giftcard/sell-rates');
  }

  async updateGiftcardRegions(id: string, data: UpdateGiftcardRegionsRequest): Promise<ApiResponse> {
    return apiManager.put(`/api/v1/admin/giftcard/sell-rates/${id}/regions`, data);
  }

  async createSubcategory(regionId: string, data: CreateGiftcardSubcategoryRequest): Promise<ApiResponse<{ id: string }>> {
    return apiManager.post(`/api/v1/admin/giftcard/regions/${regionId}/subcategories`, data);
  }

  async updateSubcategory(id: string, data: UpdateGiftcardSubcategoryRequest): Promise<ApiResponse> {
    return apiManager.put(`/api/v1/admin/giftcard/subcategories/${id}`, data);
  }

  async deleteSubcategory(id: string): Promise<ApiResponse> {
    return apiManager.delete(`/api/v1/admin/giftcard/subcategories/${id}`);
  }

  async getBuyRates(): Promise<ApiResponse<GiftcardBuyRate[]>> {
    return apiManager.get<GiftcardBuyRate[]>('/api/v1/admin/giftcard/buy-rates');
  }
}

export const giftcardService = new GiftcardService();